import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';

import '../scss/index.scss';
import '../../scss/table.scss';
import Color from '@tool/color';
import { CloseIcon20 } from '@styled/icon';
import { newRate } from '@tool/index';
import moSalaryIndustry from './store';
import PDF from '../../../component/pdf';
import Title from '../../../component/title';
import HeadPdf from '../../../component/head-pdf';
import FootPdf from '../../../component/foot-pdf';
import moIndex from '../../../store/index';
import IndicatorTable from '../../indicator-table';
import Explain from './explain';

interface IProps {}
interface IState {}

const Table = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { industry } = moIndex;
  const { xData, tableHead, tableLeft, tableRight } = moSalaryIndustry;

  useEffect(() => {
    // console.log('table right -- ', toJS(tableRight));

    return () => {};
  }, []);

  return (
    <PDF>
      <section className="salary-up-pdf_1010">
        <HeadPdf onetitle="人力资源核心指标" twotitle={industry.name} />
        <section className="content-salary-1001">
          <section className="title-1001">
            <Title title="涨薪率 - 按行业" bigTitle="人力指标" />
          </section>

          {xData.length > 5 ? (
            <IndicatorTable type="行业" tableHead={tableHead}
              tableLeft={tableLeft.slice(0, 27)} tableRight={tableRight.slice(0, 27)} />
          ) : null}

          {tableLeft.length <= 20 ? <Explain /> : null}
        </section>
        <FootPdf />
      </section>
    </PDF>
  );
};

export default observer(Table);
